// LineChart.js
import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const LineChart = ({ data }) => {
  const chartRef = useRef();

  useEffect(() => {
    if (!chartRef.current) return;

    const svg = d3.select(chartRef.current);

    // Clear existing chart
    svg.selectAll("*").remove();

    // Set up chart dimensions
    const width = 400;
    const height = 200;
    const margin = { top: 20, right: 20, bottom: 20, left: 40 };

    const chartWidth = width - margin.left - margin.right;
    const chartHeight = height - margin.top - margin.bottom;

    // Create scales
    const xScale = d3
      .scaleLinear()
      .domain([0, data.length - 1])
      .range([0, chartWidth]);
    const yScale = d3
      .scaleLinear()
      .domain([0, d3.max(data)])
      .range([chartHeight, 0]);

    // Create line function
    const line = d3
      .line()
      .x((d, i) => xScale(i))
      .y((d) => yScale(d));

    // Create chart group
    const chart = svg
      .append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);

    // Append the line to the chart
    chart.append("path").data([data]).attr("class", "line").attr("d", line);

    // Append x-axis
    chart
      .append("g")
      .attr("transform", `translate(0, ${chartHeight})`)
      .call(d3.axisBottom(xScale));

    // Append y-axis
    chart.append("g").call(d3.axisLeft(yScale));
  }, [data]);

  return <svg ref={chartRef} width={400} height={200}></svg>;
};

export default LineChart;
